"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ContentCut_exports = {};
__export(ContentCut_exports, {
  default: () => ContentCut_default
});
module.exports = __toCommonJS(ContentCut_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.72266 6.98828C8.8138 6.79297 8.87891 6.59766 8.91797 6.40234C8.97005 6.19401 8.99609 5.97917 8.99609 5.75781C8.99609 4.92448 8.70312 4.21484 8.11719 3.62891C7.53125 3.04297 6.82812 2.75 6.00781 2.75C5.17448 2.75 4.46484 3.04297 3.87891 3.62891C3.29297 4.21484 3 4.92448 3 5.75781C3 6.57812 3.29297 7.28125 3.87891 7.86719C4.46484 8.45312 5.17448 8.74609 6.00781 8.74609C6.22917 8.74609 6.4375 8.72656 6.63281 8.6875C6.84115 8.63542 7.04297 8.5638 7.23828 8.47266L8.99609 10.25L7.23828 12.0273C7.04297 11.9362 6.84115 11.8711 6.63281 11.832C6.4375 11.7799 6.22917 11.7539 6.00781 11.7539C5.17448 11.7539 4.46484 12.0469 3.87891 12.6328C3.29297 13.2188 3 13.9219 3 14.7422C3 15.5755 3.29297 16.2852 3.87891 16.8711C4.46484 17.457 5.17448 17.75 6.00781 17.75C6.82812 17.75 7.53125 17.457 8.11719 16.8711C8.70312 16.2852 8.99609 15.5755 8.99609 14.7422C8.99609 14.5208 8.97005 14.3125 8.91797 14.1172C8.87891 13.9089 8.8138 13.707 8.72266 13.5117L10.5 11.7539L15.7539 17.0078H18V16.2461L8.72266 6.98828ZM6.00781 7.24219C5.59115 7.24219 5.23307 7.09896 4.93359 6.8125C4.64714 6.51302 4.50391 6.16146 4.50391 5.75781C4.50391 5.34115 4.64714 4.98958 4.93359 4.70312C5.23307 4.40365 5.59115 4.25391 6.00781 4.25391C6.41146 4.25391 6.75651 4.40365 7.04297 4.70312C7.34245 4.98958 7.49219 5.34115 7.49219 5.75781C7.49219 6.16146 7.34245 6.51302 7.04297 6.8125C6.75651 7.09896 6.41146 7.24219 6.00781 7.24219ZM6.00781 16.2461C5.59115 16.2461 5.23307 16.1029 4.93359 15.8164C4.64714 15.5169 4.50391 15.1589 4.50391 14.7422C4.50391 14.3385 4.64714 13.9935 4.93359 13.707C5.23307 13.4076 5.59115 13.2578 6.00781 13.2578C6.41146 13.2578 6.75651 13.4076 7.04297 13.707C7.34245 13.9935 7.49219 14.3385 7.49219 14.7422C7.49219 15.1589 7.34245 15.5169 7.04297 15.8164C6.75651 16.1029 6.41146 16.2461 6.00781 16.2461ZM10.5 10.6211C10.3958 10.6211 10.3047 10.5885 10.2266 10.5234C10.1615 10.4453 10.1289 10.3542 10.1289 10.25C10.1289 10.1458 10.1615 10.0612 10.2266 9.99609C10.3047 9.91797 10.3958 9.87891 10.5 9.87891C10.6042 9.87891 10.6888 9.91797 10.7539 9.99609C10.832 10.0612 10.8711 10.1458 10.8711 10.25C10.8711 10.3542 10.832 10.4453 10.7539 10.5234C10.6888 10.5885 10.6042 10.6211 10.5 10.6211ZM15.7539 3.49219L11.2422 8.00391L12.7461 9.50781L18 4.25391V3.49219H15.7539Z",
      fill: "currentColor"
    }
  )
);
const SvgContentCut = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ContentCut_default = SvgContentCut;
